import { render, staticRenderFns } from "./SearchingTruckModal.vue?vue&type=template&id=38759542&scoped=true"
import script from "./SearchingTruckModal.vue?vue&type=script&lang=js"
export * from "./SearchingTruckModal.vue?vue&type=script&lang=js"
import style0 from "./SearchingTruckModal.vue?vue&type=style&index=0&id=38759542&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38759542",
  null
  
)

export default component.exports